const investExpertiseListedAssetsLang = {
	go_to_fund: {
		tag: 'invest.expertise_listed_assets.go_to_fund',
		fr: 'Accéder au fonds',
		en: 'Go to fund details',
	},
	global_subtitle: {
		tag: 'invest.expertise_listed_assets.global_subtitle',
		fr: 'Dernières positions connues par expertise',
		en: 'Latest known positions by expertise',
	},
	subtitle_portfolio: {
		tag: 'invest.expertise_listed_assets.subtitle_portfolio',
		fr: 'Portefeuille',
		en: 'Portfolio',
	},
	subtitle_fund_performance: {
		tag: 'invest.expertise_listed_assets.subtitle_fund_performance',
		fr: 'Performance du fonds en date du {{date}}',
		en: 'Fund performances as of {{date}}',
	},
	subtitle_fund_characteristics: {
		tag: 'invest.expertise_listed_assets.subtitle_fund_characteristics',
		fr: 'Caractéristiques du fonds',
		en: 'Fund characteristics',
	},
	header_total_net_assets: {
		tag: 'invest.expertise_listed_assets.header_total_net_assets',
		fr: 'Total investi',
		en: 'Total net assets',
	},
	header_vl: {
		tag: 'invest.expertise_listed_assets.header_vl',
		fr: 'VL (€)',
		en: 'NAV/share (€)',
	},
	ONE_DAY: {
		tag: 'invest.expertise_listed_assets.header_j1',
		fr: '1 J',
		en: 'D1',
	},
	ONE_MONTH: {
		tag: 'invest.expertise_listed_assets.header_month_1',
		fr: '1 mois',
		en: '1 month',
	},
	BEGIN_OF_YEAR: {
		tag: 'invest.expertise_listed_assets.header_ytd',
		fr: 'YTD',
		en: 'YTD',
	},
	ONE_YEAR: {
		tag: 'invest.expertise_listed_assets.header_year_1',
		fr: '1 an',
		en: '1 year',
	},
	THREE_YEARS: {
		tag: 'invest.expertise_listed_assets.header_year_3',
		fr: '3 ans',
		en: '3 years',
	},
	FIVE_YEARS: {
		tag: 'invest.expertise_listed_assets.header_year_5',
		fr: '5 ans',
		en: '5 years',
	},
	SINCE_INCEPTION: {
		tag: 'invest.expertise_listed_assets.header_at_creation',
		fr: 'Depuis création',
		en: 'Since creation',
	},
	header_classification: {
		tag: 'invest.expertise_listed_assets.header_classification',
		fr: 'Classification AMF',
		en: 'AMF classification',
	},
	header_agreement_date: {
		tag: 'invest.expertise_listed_assets.header_agreement_date',
		fr: "Date d'agrément",
		en: 'Agreement date',
	},
	header_launching_date: {
		tag: 'invest.expertise_listed_assets.header_launching_date',
		fr: 'Date de lancement de la part',
		en: 'Share launching date',
	},
	fundName: {
		tag: 'invest.expertise_listed_assets.fundName',
		fr: 'Nom du fond',
		en: 'Fund name',
	},
	labels: {
		tag: 'invest.expertiseListedAssets.labels',
		fr: 'Labels',
		en: 'Labels',
	},
	listedAssets: {
		tag: 'invest.expertiseListedAssets.listedAssets',
		fr: 'Actifs cotés',
		en: 'Listed assets',
	},
};

export default investExpertiseListedAssetsLang;
